
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import BetaHero from "@/components/recommended/BetaHero";
import TestingPhase from "@/components/recommended/TestingPhase";
import ProcessFlow from "@/components/ProcessFlow";
import TestimonialsCarousel from "@/components/TestimonialsCarousel";
import Partnerships from "@/components/Partnerships";

const RecommendedVersion = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar activePage="recommended" />
      <BetaHero />
      <TestingPhase />
      <ProcessFlow />
      <TestimonialsCarousel />
      <Partnerships />
      <Footer />
    </div>
  );
};

export default RecommendedVersion;
